var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.285C9 35.745 12.255 39 17.715 39H30.285C35.745 39 39 35.745 39 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4648 19.3047C33.4648 19.9197 32.9698 20.4297 32.3398 20.4297H24.4648C23.8498 20.4297 23.3398 19.9197 23.3398 19.3047C23.3398 18.6897 23.8498 18.1797 24.4648 18.1797H32.3398C32.9698 18.1797 33.4648 18.6897 33.4648 19.3047Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9548 17.8498L17.5798 21.2248C17.3548 21.4498 17.0698 21.5548 16.7848 21.5548C16.4998 21.5548 16.1998 21.4498 15.9898 21.2248L14.8648 20.0998C14.4148 19.6648 14.4148 18.9448 14.8648 18.5098C15.2998 18.0748 16.0048 18.0748 16.4548 18.5098L16.7848 18.8398L19.3648 16.2598C19.7998 15.8248 20.5048 15.8248 20.9548 16.2598C21.3898 16.6948 21.3898 17.4148 20.9548 17.8498Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4648 29.8047C33.4648 30.4197 32.9698 30.9297 32.3398 30.9297H24.4648C23.8498 30.9297 23.3398 30.4197 23.3398 29.8047C23.3398 29.1897 23.8498 28.6797 24.4648 28.6797H32.3398C32.9698 28.6797 33.4648 29.1897 33.4648 29.8047Z",
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9548 28.3498L17.5798 31.7248C17.3548 31.9498 17.0698 32.0548 16.7848 32.0548C16.4998 32.0548 16.1998 31.9498 15.9898 31.7248L14.8648 30.5998C14.4148 30.1648 14.4148 29.4448 14.8648 29.0098C15.2998 28.5748 16.0048 28.5748 16.4548 29.0098L16.7848 29.3398L19.3648 26.7598C19.7998 26.3248 20.5048 26.3248 20.9548 26.7598C21.3898 27.1948 21.3898 27.9148 20.9548 28.3498Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.5aef4073cd17527107a34f3de9a160a5.svg";
export { ForwardRef as ReactComponent };